/** Analytics hooks for campaign attribution (Milestone 27). */

export function trackAttributionEvent(eventType, metadata = {}) {
  if (typeof window !== "undefined" && window.__midpointTrack) {
    window.__midpointTrack(eventType, { domain: "automap_attribution", ...metadata });
  } else if (process.env.NODE_ENV !== "production") {
    console.debug("[attribution-analytics]", eventType, metadata);
  }
}
